export const composeStyles = (...values) => {
    return values.join(' ');
};
export function composeClasses(...names) {
    return names.filter(name => !!name).join(' ');
}
/** An alias to {@link composeClasses} function. */
export const cx = composeClasses;
